/* eslint-disable no-console */
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AdminPageBody } from "../../../layout/AdminPage/AdminPageBody";
import { OrderListMole } from "../../molecules";
import { OrdersWrapper } from "./Orders.style";
import { LocationOrderListToolbar } from "./LocationOrderListToolbar";

export const LocationOrderList: React.FC = () => {
  const { order50453 } = useSelector((state: any) => state.order50453);
  const history = useNavigate();
  const handelEditOrder = (id: string, productionLineId: string) => () => {
    history(`/order/production-line/${productionLineId}/order/${id}`);
  };
  return (
    <AdminPageBody pageToolbar={<LocationOrderListToolbar />}>
      <OrdersWrapper>
        <OrderListMole
          data={order50453}
          showPagination
          showLocation={false}
          showProduction
          showDeleteBtn={false}
          editOrder={handelEditOrder}
        />
      </OrdersWrapper>
    </AdminPageBody>
  );
};
